import { render, staticRenderFns } from "./TweetModal.vue?vue&type=template&id=a5696962&scoped=true&"
import script from "./TweetModal.vue?vue&type=script&lang=js&"
export * from "./TweetModal.vue?vue&type=script&lang=js&"
import style0 from "./TweetModal.vue?vue&type=style&index=0&id=a5696962&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5696962",
  null
  
)

export default component.exports